import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col } from 'react-bootstrap';
import HomeButton from './buttons/HomeButton'
import CurriculumVitaeButton from './buttons/CurriculumVitaeButton'
import WorksButton from './buttons/WorksButton'
import ContactButton from './buttons/ContactButton'

import pic1 from '../static/images/legalAreasPic1.jpg'
import pic2 from '../static/images/legalAreasPic2.jpg'
import pic3 from '../static/images/legalAreasPic3.jpg'

class LegalAreas extends Component {
    render() {
        let altImg = 'And justice for all...'
        let title;
        let text1;
        let text2;
        let text3;
        switch(this.props.language){
            case 'Croatian':
                title = 'Pravna područja'
                text1 =
                    <div>
                        <h3>Građansko i trgovačko pravo</h3><hr />
                        <h5>Pružamo pravne usluge zastupanja, savjetovanja te sastavljanja ugovora i drugih pravnih isprava u domeni građanskog i trgovačkog prava:</h5>
                        <h5>1. imovinsko-pravni odnosi</h5>
                        <h5>2. građanski i trgovački obvezni odnosi</h5>
                        <h5>3. radno pravo</h5>
                        <h5>4. nasljedno pravo</h5>
                        <h5>5. zemljišno-knjižno pravo</h5>
                        <h5>6. ovršno pravo</h5>
                        <h5>7. čekovno i mjenično pravo</h5>
                        <h5>8. bankarsko pravo</h5>
                        <h5>9. stečajno pravo</h5>
                        <h5>10. odštetno pravo</h5>
                        <h5>11. transportno pravo</h5> 
                    </div>
                text2 = 
                    <div>
                        <h3>Kazneno i prekršajno pravo</h3><hr />
                        <h5>Pružamo pravne usluge savjetovanja, zastupanja i obrane u kaznenim i prekršajnim postupcima.</h5>
                    </div>
                text3 =
                    <div>
                        <h3>Upravno pravo</h3><hr />
                        <h5>Pružamo pravne usluge zastupanja, savjetovanja te sastavljanja ugovora i svih drugih pravnih isprava u domeni upravnog prava.</h5>
                    </div>
                break
            default:
                title = 'Legal areas'
                text1 =
                    <div>
                        <h3>Civil and commercial law</h3><hr />
                        <h5>We provide legal advocacy services, counseling and contract drafting and other legal documents in the field of civil and commercial law:</h5>
                        <h5>1. property relations</h5>
                        <h5>2. civil and commercial obligatory relations</h5>
                        <h5>3. labor law</h5>
                        <h5>4. law of succession</h5>
                        <h5>5. land registry law</h5>
                        <h5>6. enforcement law</h5>
                        <h5>7. checkbook and bill law</h5>
                        <h5>8. banking law</h5>
                        <h5>9. bankruptcy law</h5>
                        <h5>10. tort law</h5>
                        <h5>11. transport law</h5> 
                    </div>
                text2 = 
                    <div>
                        <h3>Criminal and tort law</h3><hr />
                        <h5>We provide legal counseling, representation and defense in criminal and tort proceddings.</h5>
                    </div>
                text3 =
                    <div>
                        <h3>Administrative law</h3><hr />
                        <h5>We provide legal advocacy services, counseling and contract drafting and other legal documents in the field of administrative law.</h5>
                    </div>
        }
        return (
            <div>
                <Row>
                    <HomeButton />
                    <CurriculumVitaeButton />
                    <WorksButton />
                    <ContactButton />
                </Row>
                <br />
                <h2>{title}</h2>
                <hr className="hrBig" />
                <Row>
                    <Col md={7}>
                        <img src={pic1} className="bigPic" alt={altImg} />
                    </Col>
                    <Col md={5}>
                        {text1}
                    </Col>
                </Row>
                <hr className="hrBig" />
                <Row>
                    <Col md={7}>
                        <img src={pic2} className="bigPic" alt={altImg} />
                    </Col>
                    <Col md={5}>
                        {text2}
                    </Col>
                </Row>
                <hr className="hrBig" />
                <Row>
                    <Col md={7}>
                        <img src={pic3} className="bigPic" alt={altImg} />
                    </Col>
                    <Col md={5}>
                        {text3}
                    </Col>
                </Row>
                <hr />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
      language: state.language 
    };
  };

export default connect(mapStateToProps, null)(LegalAreas);


// WEBPACK FOOTER //
// ./src/screens/LegalAreas.js